import { Signal, signal } from '@angular/core';

/**
 * Een telefoon, staand of liggend. Staand tot 767.98 px, liggend alles tot
 * 991.98 px; dezelfde vraag als Live (RecorderComponent.TELEFOON). Een iPad
 * valt erbuiten, ook een iPad 11" staand (820 px).
 *
 * Waarvoor (eigenaar 05-10-2026): de iPhone is om snel events en playlists
 * terug te kijken, te communiceren en de basiscijfers van een speler te zien.
 * Geavanceerde stats horen op de iPad of de computer, "daarvoor is het scherm
 * te klein". Uitzondering sinds 12-10-2026: de Stats-pagina per wedstrijd,
 * want spelers kijken op hun iPhone ("Een speler zal hoofdzakelijk op zijn
 * iPhone in portrait mode kijken"); daar met een eigen telefoonopmaak.
 */
export const TELEFOON = '(max-width: 767.98px), (orientation: landscape) and (max-width: 991.98px)';

/** Nu een telefoon? Voor een eenmalige vraag, zoals in een route-guard. */
export function isTelefoon(): boolean {
  return typeof window !== 'undefined' && !!window.matchMedia && window.matchMedia(TELEFOON).matches;
}

let gedeeld: Signal<boolean> | null = null;

/** Een telefoon, als signaal: volgt het draaien van het toestel. */
export function telefoon(): Signal<boolean> {
  if (!gedeeld) {
    const stand = signal(isTelefoon());
    if (typeof window !== 'undefined' && window.matchMedia) {
      window.matchMedia(TELEFOON).addEventListener('change', e => stand.set(e.matches));
    }
    gedeeld = stand.asReadonly();
  }
  return gedeeld;
}
